import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import Breadcrumbs from "@/components/layout/Breadcrumbs";
import { Clock, Calendar } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then(({ data }) => setPost(data)).catch(() => {}); }, [slug]);
  if (!post) return <div className="container-page py-20 text-center text-slate-500">Loading…</div>;

  const date = post.published_at ? new Date(post.published_at).toLocaleDateString("en-IN", { dateStyle: "long" }) : "";

  return (
    <article data-testid={`blog-post-${slug}`} className="bg-white">
      <div className="relative h-[300px] md:h-[420px] overflow-hidden">
        <img src={post.image} alt={post.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/30 via-slate-900/40 to-slate-900/80" />
        <div className="container-page relative z-10 h-full flex flex-col justify-end pb-10 text-white">
          <div className="text-xs font-bold uppercase tracking-widest text-accent mb-3">{post.category}</div>
          <h1 className="font-montserrat font-extrabold text-3xl md:text-5xl tracking-tight max-w-3xl">{post.title}</h1>
          <div className="mt-4 flex items-center gap-4 text-sm text-white/85">
            <span>By {post.author}</span>
            <span className="inline-flex items-center gap-1"><Calendar size={14} /> {date}</span>
            <span className="inline-flex items-center gap-1"><Clock size={14} /> {post.read_time}</span>
          </div>
        </div>
      </div>
      <div className="container-page py-10 max-w-3xl">
        <Breadcrumbs items={[{ label: "Blog", to: "/blog" }, { label: post.title.slice(0, 40) }]} />
        <div className="prose-slate text-slate-700 leading-relaxed text-[17px] space-y-5 whitespace-pre-line">
          {post.content}
        </div>
      </div>
    </article>
  );
}
